import { render, staticRenderFns } from "./personalDetailList.vue?vue&type=template&id=138f5ddf&"
import script from "./personalDetailList.vue?vue&type=script&lang=js&"
export * from "./personalDetailList.vue?vue&type=script&lang=js&"
import style0 from "./personalDetailList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports